import Loader from "./Loader";

export default function PageLoader({ label = "Chargement", variant = "primary" }) {
  return (
    <div className="loader-fullscreen" role="status" aria-live="polite">
      <Loader size="large" variant={variant} label={label} />
    </div>
  );
}
